export default {
  data() {
    return {
      _throttlers_map: new Map()
    }
  },

  methods: {
    _handle_throttle(fn, args, delay = 0) {
      let throttler = this._throttlers_map.get(fn)

      if (!throttler) {
        let ticking = false
        let last_args = null
        let last_call_time = 0

        throttler = (...innerArgs) => {
          last_args = innerArgs
          const now = performance.now()

          const invokeFn = () => {
            fn(...last_args)
            last_call_time = performance.now()
            ticking = false
          }

          if (!ticking) {
            const since_last_call = now - last_call_time
            ticking = true

            if (since_last_call >= delay) {
              throttler._raf_id = requestAnimationFrame(() => {
                invokeFn()
              })
            } else {
              throttler._raf_id = requestAnimationFrame(() => {
                ticking = false
                throttler.apply(this, last_args)
              })
            }
          }
        }

        throttler.abort = () => {
          if (throttler._raf_id !== undefined) {
            cancelAnimationFrame(throttler._raf_id)
            throttler._raf_id = undefined
          }
        }

        this._throttlers_map.set(fn, throttler)
      }

      throttler(...args)
    },

    $abortThrottle(fn) {
      const throttler = this._throttlers_map.get(fn)
      if (throttler) throttler.abort()
    },

    $throttle(fn, ...args) {
      this._handle_throttle(fn, args)
    },

    $throttle_200(fn, ...args) {
      this._handle_throttle(fn, args, 200)
    },

    $throttle_500(fn, ...args) {
      this._handle_throttle(fn, args, 500)
    },

    $throttle_1000(fn, ...args) {
      this._handle_throttle(fn, args, 1000)
    }
  },

  beforeUnmount() {
    this._throttlers_map.forEach((throttler, fn, map) => {
      if (throttler.raf_id !== undefined) cancelAnimationFrame(throttler.raf_id)
      map.delete(fn)
    })
  }
}
